import { ColorSet } from "../components/colorSelect/ColorSelect";

// メッセージ
export module ConstMessage {
    export const ERR_UNSUPPORT_IMG_FILE_TYPE = 'JPEG または PNG ファイルを選択してください。';
    export const INPUT_ERR_LINK_MENU_NAME_LINE = '3行以下で入力してください。';
    export const INPUT_ERR_LINK_MENU_NAME_COUNT = '1行につき10文字以内で入力してください。';
    export const ERR_SAVE_REPLY_BUTTONS_NAME = 'この設定名は既に登録されています。';
    export const SUCCESS_SAVE_REPLY_BUTTONS = 'ボタンを保存しました。';
    export const SUCCESS_DELETE_REPLY_BUTTONS = '削除しました。';
    export const ERR_FAILURE_TO_NETWORK_CONNECTION = 'ネットワークに接続できません。';
    export const ERR_FAILURE_TO_SAVE_REPLY_BUTTONS = '保存に失敗しました。';
    export const ERR_INPUT_KANA_ALPHA_NUM = 'カナ英数字で入力してください。';
    export const ERR_ONLINE_URLS_DUPLICATION = 'このミーティングURL名は既に登録されています。';
    export const WARN_REGISTED_ADMIN_EMAIL = '登録済のメールアドレスです。';
    export const CSV_EXPORT_TITLE = 'CSV出力';
    export const ERR_CSV_EXPORT = 'CSV出力に失敗しました。';
    export const ERR_CSV_EXPORT_NOT_DATA = '出力可能な利用者がいないためCSV出力ができませんでした。';
    export const PROGRESS_SUB_TEXT = 'この処理には1時間以上かかる場合があります。';
    export const ERR_USER_IDCARD_PDF_ACCOUNT = '利用者が停止状態です。';
    export const ERR_USER_IDCARD_PDF_LAST_NAME = '利用者名が設定されていません。';
    export const ERR_USER_IDCARD_PDF_UNDEFINED_ID = '存在しない利用者番号です。';
    export const ERR_USER_ID_CARD_PDF_CREATE = 'PDFの作成に失敗しました。';
    export const SUCCESS_USER_ID_CARD_PDF_DOWNLOAD = 'PDFのダウンロードに成功しました。';
    export const ERR_USER_ID_CARD_PDF_DOWNLOAD = 'PDFのダウンロードに失敗しました。';
    export const ERR_USER_ID_CARD_NOTHING_EXCEL_FILE = 'Excelファイルが見つかりませんでした。';
    export const ERR_GET_DATA = 'データの取得に失敗しました。';
    export const SUCCESS_SEND_MAIL = 'メールの送信が完了しました。';
    export const ERR_SEND_MAIL = 'メールの送信に失敗しました。';
    export const OPTION_CONTRACT_CONFIRM_START_DATE_IS_FUTURE_TEXT = '開始日が未来のため契約状況は開始日まで「有効（開始待ち）」になります。';
};

// 定数
export module ConstValue {
    export const IMG_MAX_FILE_SIZE = 500000; // KB
    export const IMG_MAX_WH = 1920; // px
    export const appTheme: Object = [
        { id: "none", name: "なし" },
        { id: "orange", name: "橙" },
        { id: "purple", name: "紫" },
        { id: "blue", name: "青" },
        { id: "pink", name: "ピンク" },
        { id: "red", name: "赤" },
    ]; // アプリテーマ
    export const lightColor: ColorSet[] = [
        { colorName: 'pink', className: 'bg-[#FFB7E5]', hex: '#FFB7E5' },
        { colorName: 'purple', className: 'bg-[#E8B7FF]', hex: '#E8B7FF' },
        { colorName: 'blue', className: 'bg-[#B7D0FF]', hex: '#B7D0FF' },
        { colorName: 'light-blue', className: 'bg-[#B7F1FF]', hex: '#B7F1FF' },
        { colorName: 'green', className: 'bg-[#B7FFC5]', hex: '#B7FFC5' },
        { colorName: 'yellow', className: 'bg-[#FFFFB7]', hex: '#FFFFB7' },
        { colorName: 'orange', className: 'bg-[#FFDEB7]', hex: '#FFDEB7' },
        { colorName: 'red', className: 'bg-[#FFBDB7]', hex: '#FFBDB7' },
        { colorName: 'white', className: 'bg-[#FFFFFF]', hex: '#FFFFFF' }
    ]; // テーマカラー:lightColor  薄い配色[ピンク、紫、青、水色、緑、黄色、オレンジ、赤]
    export const darkColor: ColorSet[] = [
        { colorName: 'pink', className: 'bg-[#CE3797]', hex: '#CE3797' },
        { colorName: 'purple', className: 'bg-[#9437CE]', hex: '#9437CE' },
        { colorName: 'blue', className: 'bg-[#3D37CE]', hex: '#3D37CE' },
        { colorName: 'light-blue', className: 'bg-[#2C89D8]', hex: '#2C89D8' },
        { colorName: 'green', className: 'bg-[#009E18]', hex: '#009E18' },
        { colorName: 'yellow', className: 'bg-[#949A00]', hex: '#949A00' },
        { colorName: 'orange', className: 'bg-[#C18600]', hex: '#C18600' },
        { colorName: 'red', className: 'bg-[#CE3737]', hex: '#CE3737' },
        { colorName: 'white', className: 'bg-[#FFFFFF]', hex: '#FFFFFF' }
    ]; // テーマカラー:darkColor  濃い配色[ピンク、紫、青、水色、緑、黄色、オレンジ、赤]
};

// セッションキー
export module SessionKey {
    export const HAS_DUPLICATED_STAFF_MAIL = 'hasDuplicatedStaffMail';
    export const SELECTED_TENANT_ID = 'selectedTenantId';
    export const USER_ID_CARD_AUTH = 'userIdCardAuth';
};